// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let DateFns = require("date-fns");
let CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let TailwindMerge = require("tailwind-merge");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql = require("../../__generated__/PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.bs.js");
let PropertyPageForSalePropertySidecardMlsInfo_property_graphql = require("../../__generated__/PropertyPageForSalePropertySidecardMlsInfo_property_graphql.bs.js");

let convertFragment = PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__ForSalePropertySidecard__MlsInfo$FromMlsPlan(props) {
  let mlsPlan = RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertySidecardMlsInfo_mlsPlan_graphql.node, convertFragment, props.mlsPlan);
  let match;
  switch (mlsPlan.__typename) {
    case "ListOnMlsAsActive" :
      match = [
        Primitive_option.some(mlsPlan.onMlsAt),
        mlsPlan.willShowPriorToMls,
        mlsPlan.willAcceptOffersPriorToMls
      ];
      break;
    case "ListOnMlsAsComingSoon" :
      match = [
        Primitive_option.some(mlsPlan.activeOnMlsOn),
        mlsPlan.willShowPriorToMls,
        mlsPlan.willAcceptOffersPriorToMls
      ];
      break;
    case "NoMlsPlan" :
      match = [
        undefined,
        mlsPlan.willShow,
        mlsPlan.willAcceptOffers
      ];
      break;
    case "__unselected" :
      match = UnselectedUnionMemberError.raise(`Unselected PropertyForEditingResult ` + mlsPlan._0);
      break;
  }
  let onMlsAt = match[0];
  let items = [
    match[1] ? "Will show before MLS" : "Won't show before MLS",
    match[2] ? "Will accept offers before MLS" : "Won't accept offers before MLS"
  ];
  return JsxRuntime.jsxs("div", {
    children: [
      onMlsAt !== undefined ? JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx("div", {
              children: "Expected on MLS",
              className: "text-gray-500 uppercase font-medium tracking-wide"
            }),
            JsxRuntime.jsx("div", {
              children: DateFns.format(CalendarDate.toLocalDate(Primitive_option.valFromOption(onMlsAt)), "MMM d, YYY"),
              className: "text-lg font-medium"
            })
          ],
          className: "space-y-2"
        }) : null,
      JsxRuntime.jsx("ul", {
        children: items.map((item, index) => JsxRuntime.jsxs("li", {
          children: [
            JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(IconV5.make, {
                icon: "bullet",
                className: "text-zinc-400"
              }),
              className: "-mb-2 mr-2"
            }),
            item
          ],
          className: "flex flex-row space-x-2 font-medium"
        }, index.toString())),
        className: "mt-2 space-y-3"
      })
    ],
    className: TailwindMerge.twMerge([
      "space-y-4",
      Stdlib_Option.getOr(props.className, "")
    ])
  });
}

let FromMlsPlan = {
  Fragment: Fragment,
  make: PropertyPage__ForSalePropertySidecard__MlsInfo$FromMlsPlan
};

let convertFragment$1 = PropertyPageForSalePropertySidecardMlsInfo_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1, fRef);
}

let Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyPage__ForSalePropertySidecard__MlsInfo$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertySidecardMlsInfo_property_graphql.node, convertFragment$1, props.property);
  return JsxRuntime.jsx(PropertyPage__ForSalePropertySidecard__MlsInfo$FromMlsPlan, {
    mlsPlan: match.mlsPlan.fragmentRefs,
    className: props.className
  });
}

let WithoutErrorBoundary = {
  Fragment: Fragment$1,
  make: PropertyPage__ForSalePropertySidecard__MlsInfo$WithoutErrorBoundary
};

function PropertyPage__ForSalePropertySidecard__MlsInfo(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "property MLS info",
    children: JsxRuntime.jsx(PropertyPage__ForSalePropertySidecard__MlsInfo$WithoutErrorBoundary, {
      property: props.property,
      className: props.className
    })
  });
}

let make = PropertyPage__ForSalePropertySidecard__MlsInfo;

exports.FromMlsPlan = FromMlsPlan;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* IconV5 Not a pure module */
